var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('markdownEditor',{on:{"imageAdded":_vm.catchImage},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}}),_c('vue-markdown',{attrs:{"source":_vm.decodeMarkdownToLinks(_vm.content)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }